import axios, { AxiosError } from "axios";
const API_URL = process.env.NEXT_PUBLIC_API_URL;
interface PriceListDetails {
  flat_id: string;
  sold_out_date: string;
  unit: string;
  price: number | null;
  area: number;
  bath_counting: number;
  room_counting: number;
  status: string;
  facing: string;
  price_psf: number | null;
  plan: string;
  type: string;
  type_feature?: string | null;
}
export const getPriceList = async ({ id }: { id: string }) => {
  try {
    const response = await axios.get(
      `${API_URL}/property-meta-data/export-pricelist/${id}`
    );
    if (Array.isArray(response?.data)) {
      const mappedData = response?.data?.map((item: PriceListDetails) => ({
        id: item?.flat_id,
        status: item?.status,
        unit: item?.unit,
        area: item?.area,
        price: item?.price,
        pricePerSf: item?.price_psf,
        beds: item?.room_counting,
        baths: item?.bath_counting,
        plan: item?.plan,
        type: item?.type,
        typeFeature: item?.type_feature ?? null,
      }));
      return mappedData;
    }
  } catch (error: unknown) {
    if (error instanceof AxiosError) {
      return null;
      throw new Error("Failed to fetch Price List");
    }
  }
};
